import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { Event } from 'services/EventEmitter';

/**
 * This is a description of the SearchUpdater constructor function.
 * @class
 * @classdesc This class is using to render wrapped component on 'search.updated' event.
 * @extends Component
 */
export default class SearchUpdater extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            dataModelId: null,
            templateName: null,
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        Event.on('search.updated', this.onSearchUpdated, this);
    }

    /**
     * Search Updated event handler
     *
     * @param {Object} data Data due to refinement to be changed
     */
    onSearchUpdated(data) {
        const dataModel = this.options.dataModelId && data[this.options.dataModelId];
        if (dataModel) {
            this.render(dataModel, {
                replaceChildren: true,
            });
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('search.updated', this.onProductUpdated, this);
    }
}
